import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Component({
    selector: 'snackbar-go-to-new-customer',
    templateUrl: './snackbar-go-to-new-customer.component.html',
    styleUrls: ['./snackbar-go-to-new-customer.component.scss'],
    standalone: false
})
export class snackbarGoToNewCustomer  {
    
  constructor(

    private snackBarRef: MatSnackBarRef<snackbarGoToNewCustomer>,
    private router: Router,
    @Inject(MAT_SNACK_BAR_DATA) public customerId: number
  ) {}
  
  ngOnInit() {

  }
  
  navigateToNewCustomer() {
    
    this.snackBarRef.dismiss(); // Close the snackbar
    console.log(this.customerId)
      this.router.navigate(['relations/customers/details', this.customerId]);
  }
  
  Dismiss() {
    this.snackBarRef.dismiss();
  }
}
